import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";

const MaTravelPackageDetails = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [pkg, setPkg] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const { data } = await axios.get(
                    `/maTravelPackageDetails/${id}`
                );
                setPkg(data);
            } catch (err) {
                setError("Failed to load travel package details");
            } finally {
                setLoading(false);
            }
        })();
    }, [id]);

    if (loading) {
        return (
            <Wrapper>
                <InnerNav />
                <p className="mt-4 text-gray-600">Loading package details...</p>
            </Wrapper>
        );
    }

    if (error) {
        return (
            <Wrapper>
                <InnerNav />
                <p className="mt-4 text-red-600">{error}</p>
            </Wrapper>
        );
    }

    if (!pkg) {
        return null;
    }

    return (
        <Wrapper>
            <InnerNav />

            {/* HEADER */}
            <div className="mb-6">
                <h1 className="text-2xl font-bold">
                    {pkg.name}
                </h1>

                <div className="mt-2 text-gray-700">
                    <p>
                        <span className="font-semibold">Date Range:</span>{" "}
                        {pkg.date_range}
                    </p>
                    <p>
                        <span className="font-semibold">Total Cost:</span>{" "}
                        <span className="text-green-700 font-bold">
                            KES {Number(pkg.total_cost).toLocaleString()}
                        </span>
                    </p>
                </div>
            </div>

            {/* ITEMS */}
            <div className="mb-8">
                <h2 className="text-xl font-semibold mb-3">
                    Package Items
                </h2>

                {pkg.items && pkg.items.length > 0 ? (
                    <div className="overflow-x-auto">
                        <table className="w-full border text-sm">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="border px-3 py-2 text-left">
                                        Item
                                    </th>
                                    <th className="border px-3 py-2 text-right">
                                        Qty
                                    </th>
                                    <th className="border px-3 py-2 text-right">
                                        Unit Price
                                    </th>
                                    <th className="border px-3 py-2 text-right">
                                        Total
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {pkg.items.map((item) => (
                                    <tr key={item.id}>
                                        <td className="border px-3 py-2">
                                            {item.item}
                                        </td>
                                        <td className="border px-3 py-2 text-right">
                                            {item.qty}
                                        </td>
                                        <td className="border px-3 py-2 text-right">
                                            {Number(item.unit_price).toLocaleString()}
                                        </td>
                                        <td className="border px-3 py-2 text-right">
                                            {Number(item.total).toLocaleString()}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="text-gray-500">
                        No items defined for this package.
                    </p>
                )}
            </div>

            {/* INCLUSIONS */}
            <div className="mb-8">
                <h2 className="text-xl font-semibold mb-2">
                    Inclusions
                </h2>

                {pkg.inclusions && pkg.inclusions.length > 0 ? (
                    <ul className="list-disc pl-6 space-y-1 text-green-700">
                        {pkg.inclusions.map((inc) => (
                            <li key={inc.id}>
                                {inc.inclusion}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-gray-500">
                        No inclusions specified.
                    </p>
                )}
            </div>

            {/* EXCLUSIONS */}
            <div className="mb-8">
                <h2 className="text-xl font-semibold mb-2">
                    Exclusions
                </h2>

                {pkg.exclusions && pkg.exclusions.length > 0 ? (
                    <ul className="list-disc pl-6 space-y-1 text-red-700">
                        {pkg.exclusions.map((exc) => (
                            <li key={exc.id}>
                                {exc.exclusion}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-gray-500">
                        No exclusions specified.
                    </p>
                )}
            </div>
        </Wrapper>
    );
};

export default MaTravelPackageDetails;
